import React, { useState } from 'react';

interface MenuItem {
  label: string;
  href: string;
  badge?: string; // Optional cyber status tags
}

export const LandingHeader: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isPreLaunchMode = process.env.REACT_APP_PRE_LAUNCH_MODE === "true";
  const isEarlyAccessMode = process.env.REACT_APP_SHOW_EARLY_ACCESS_MODE === "true";


  const menuItems: MenuItem[] = [
    // { label: 'OVERVIEW', href: '/' },
  
    ...(isPreLaunchMode
      ? []
      : [
          { label: 'LOGIN', href: '/login' },
          // { label: 'PRICING', href: '/pricing' },
        ]),
  
    { label: 'ABOUT', href: '/about' },
    { label: 'HOW IT WORKS', href: '/how-it-works' },
    { label: 'Trust', href: '/trust-transparency' },
    { label: 'FAQ', href: '/faq-policy' },
    { label: 'CONTACT', href: '/contact-us' },  
    { label: 'PRICING', href: '/pre-launch-pricing' },

    ...(isEarlyAccessMode
      ? [
        { label: 'GET EARLY ACCESS', href: '/early-access', badge: 'ONLINE' },
      ]
      : [
        { label: 'GET EARLY ACCESS', href: '/prelaunch', badge: 'COMING SOON' },
        ]),
  ];

  
  return (
    <header className="w-full bg-slate-900 border-b border-slate-700/80 sticky top-0 z-50 backdrop-blur-md bg-opacity-95">
      {/* High-vibrancy multi-color neon accent border */}
      <div className="h-[2px] w-full bg-gradient-to-r from-cyan-500 via-indigo-500 to-fuchsia-500 shadow-[0_1px_10px_rgba(34,211,238,0.3)]" />
      
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Brand / Logo Node */}
        <div onClick={() => window.location.href = "/"}
        className="flex items-center gap-3 group cursor-pointer">
          <div className="w-3 h-3 bg-gradient-to-tr from-cyan-400 to-fuchsia-500 animate-pulse rounded-sm shadow-[0_0_10px_#22d3ee]" />
          <span className="font-mono text-lg font-black tracking-widest bg-gradient-to-r from-slate-100 via-slate-200 to-cyan-400 bg-clip-text text-transparent">
            NEXGENT<span className="text-transparent bg-gradient-to-r from-cyan-400 to-fuchsia-400 bg-clip-text font-normal">.TECH</span>
          </span>
        </div>

        {/* Desktop Navigation Menu */}
        <nav className="hidden md:flex items-center gap-8">
          {menuItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className="group relative py-2 text-xs font-mono tracking-widest text-slate-400 hover:text-cyan-400 transition-colors duration-200"
            >
              {/* Vibrant neon hover brackets */}
              <span className="text-cyan-500/30 mr-1 group-hover:text-fuchsia-400 font-sans transition-colors">[</span>
              <span className="group-hover:text-slate-100 transition-colors">{item.label}</span>
              <span className="text-cyan-500/30 ml-1 group-hover:text-fuchsia-400 font-sans transition-colors">]</span>
              
             {/* System status badge upgraded to a high-visibility tactical radar badge */}
               {item.badge && (
               <span className="absolute -top-3.5 -right-12 flex items-center gap-1.5 bg-emerald-950 border border-emerald-400 text-emerald-400 font-mono text-[9px] font-bold tracking-widest px-2 py-0.5 rounded shadow-[0_0_14px_rgba(16,185,129,0.6)] animate-[pulse_2s_infinite]">
                 {/* Concentric pulsing radar ring */}
               <span className="relative flex h-1.5 w-1.5">
               <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
               <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-400 shadow-[0_0_8px_#10b981]"></span>
               </span>
               {item.badge}
                </span>
                )}
              
              {/* Dual-color dynamic slide line */}
              <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-gradient-to-r from-cyan-400 to-fuchsia-500 transition-all duration-300 group-hover:w-full shadow-[0_0_8px_#22d3ee]" />
            </a>
          ))}
        </nav>

        {/* Mobile Menu Action Key */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 border border-slate-700 bg-slate-950/40 rounded p-1.5 focus:outline-none focus:border-cyan-500/50 group transition-all"
          aria-label="Toggle System Menu"
        >
          <span className={`h-[2px] w-full rounded-sm transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-[5px] bg-fuchsia-400' : 'bg-cyan-400 group-hover:bg-cyan-300'}`} />
          <span className={`h-[2px] w-full rounded-sm my-[3px] transition-all duration-200 ${isOpen ? 'opacity-0' : 'bg-slate-400 group-hover:bg-slate-200'}`} />
          <span className={`h-[2px] w-full rounded-sm transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-[5px] bg-fuchsia-400' : 'bg-cyan-400 group-hover:bg-cyan-300'}`} />
        </button>
      </div>

      {/* Mobile Navigation Drawer Dropdown */}
      {isOpen && (
        <div className="md:hidden border-t border-slate-800 bg-slate-950/95 backdrop-blur-lg animate-[fadeIn_0.15s_ease-out]">
          <nav className="flex flex-col p-6 space-y-4">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-between py-2 border-b border-slate-900 font-mono text-xs tracking-widest text-slate-400 hover:text-fuchsia-400 transition-colors group"
              >
                <span className="group-hover:text-slate-100 transition-colors">
                  <span className="text-cyan-500 group-hover:text-fuchsia-500">//</span> {item.label}
                </span>
                {item.badge ? (
                  <span className="bg-emerald-950 text-emerald-400 text-[10px] px-1.5 py-0.5 rounded border border-emerald-800/40 shadow-[0_0_6px_rgba(16,185,129,0.1)]">
                    {item.badge}
                  </span>
                ) : (
                  <span className="text-cyan-500 group-hover:text-fuchsia-400 font-sans text-sm transition-transform group-hover:translate-x-1">→</span>
                )}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};